import { useState, useEffect, RefObject, useMemo } from "react";

export function useIntersectionObserver(elementRef, options) {
  const [isIntersecting, setIsIntersecting] = useState(false);

  const observerOptions = useMemo(
    () => options,
    [options.threshold, options.root, options.rootMargin]
  );

  useEffect(() => {
    const element = elementRef.current;

    if (!element) {
      return;
    }

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsIntersecting(true);
        observer.unobserve(element);
      }
    }, observerOptions);

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [elementRef, observerOptions]);

  return isIntersecting;
}
